import Vue from 'vue'
import Router from 'vue-router'
import Resource from 'vue-resource'
import Validator from 'vue-validator'
// 首页导航条
import Home from '@/view/home'
// 注册
import Register from '@/view/register'
// 登录
import Login from '@/view/login'
// 首页内容
import Hello from '@/view/home_content/hello'
//预约列表
import Menu from '@/view/reservation/menu'
import ConventionList from '@/view/reservation/conventionList'
// 个人信息
import Personal from '@/view/information/personal'
// 组方
import project from '@/view/project/project'
import AddNew from '@/view/project/addNew'
import Package from '@/view/project/package'
//药品库信息
import pharmacy from '@/view/pharmacy/menu'
import IntoHouse from '@/view/pharmacy/intoHouse'
import OutSummary from '@/view/pharmacy/outSummary'
import OutHouse from '@/view/pharmacy/outHouse'
import NowStock from '@/view/pharmacy/nowStock'
import CheckStock from '@/view/pharmacy/checkStock'
import Newinto from '@/view/pharmacy/newinto'
import Audit from '@/view/pharmacy/audit'
import Check from '@/view/pharmacy/check'
import Checkout from '@/view/pharmacy/checkout'
import Newbutton from '@/view/pharmacy/newbutton'
import Details from '@/view/pharmacy/details'
import Newdrugs from '@/view/pharmacy/newdrugs'
import InventoryAudit from '@/view/pharmacy/inventoryAudit'
//药房信息
import medicine from '@/view/medicine/medicine_menu'
import Medicine_list from '@/view/medicine/medicine_list'
import MedicineDetail from '@/view/medicine/medicineDetail'
//病人库
import patient from '@/view/patient/patientmenu'
import Dashboard from '@/view/patient/dashboard'
import Patientlist from '@/view/patient/patientlist'
import addone from '@/view/patient/addone' 
//收费信息
import charge from '@/view/charge/charge_menu'
import Charge_list from '@/view/charge/charge_list'
import ChargeDetail from '@/view/charge/chargeDetail' 
//五诊合参
import inquiryList from '@/view/inquiry/inquiryList'
import Inquiry from '@/view/inquiry/inquiry'
import InquiryNone from '@/view/inquiry/inquiryNone'
import compileC from '@/view/inquiry/compileC'
// 排班模块
import Arrange from '@/view/arrange/arrange_menu'
import arrange1 from '@/view/arrange/arrange'; 
import AddWork from '@/view/arrange/new_add_work';
// 预约模块
import Reservation from '@/view/reservation/reservation'
import Mrliu from '@/view/reservation/Mrliu'
import Visdoctor from '@/view/reservation/Visdoctor'
// 预约码
import subscribeCode from '@/view/subscribeCode/subscribeCodeMenu'
import subscribeCode_Li from '@/view/subscribeCode/subscribeCode_Li'
import createCode from '@/view/subscribeCode/createCode'
//用章管理
import chapterManagement from '@/view/chapterManagement/chapterManagementMenu'
import chapterManagementLi from '@/view/chapterManagement/chapterManagementLi'
import increase from '@/view/chapterManagement/increase'

//绩效管理
import performance from '@/view/performance/performanceMenu'
import performanceLi from '@/view/performance/performanceLi'
import generate from '@/view/performance/generate'


Vue.use(Router);
Vue.use(Resource);
Vue.use(Validator);

export default new Router({
  routes: [ 
    {path: '/', component: Login},
    {path: '/register', component: Register},
    {
      path: '/home', component: Home, name: '',
      children: [
        {path: 'personal', component: Personal, name: '个人信息'},
        {path: 'hello', component: Hello, name: '子首页'},
        {path: 'menu', component: Menu, name: '预约详情',
        children:[
            {path: 'conventionList', component: ConventionList, name: '预约详情'},
            {path:'/',redirect:'conventionList'}
        ]
        },
        {path: 'inquiryList', component: inquiryList, name: '五诊合参用户列表'},
        {path: 'Inquiry', component: Inquiry, name: '五诊合参'},
        {path: 'Noinquiry', component: InquiryNone, name: '无看诊'},
        {path: 'compileC', component: compileC, name: '补录汤方'},
        {
          path: 'arrange', component: Arrange, name: '排班',
          children: [
            {path: 'arrange', component: arrange1},
            {path: 'new_add_work', component: AddWork},
            {path: '/', redirect: 'arrange'}
          ]
        },
        {
          path: 'pharmacy', component: pharmacy, name: '药品库', children: [
            {path: 'nowStock', component: NowStock, name: '当前库存'},
            {path: 'outHouse', component: OutHouse, name: '出库管理'},
            {path: 'intoHouse', component: IntoHouse, name: '入库管理'},
            {path: 'outSummary', component: OutSummary, name: '出库汇总'},
            {path: 'checkStock', component: CheckStock, name: '库存盘点'},
            {path: 'newinto', component: Newinto, name: '新增入库'},
            {path: 'audit', component: Audit, name: '审核'},
            {path: 'check', component: Check, name: '查看详情'},
            {path: 'checkout', component: Checkout, name: '查看详情'},
            {path: 'newbutton', component: Newbutton, name: '新增盘点'},
            {path: 'details', component: Details, name: '盘点详情'},
            {path: 'newdrugs', component: Newdrugs, name: '新增药品'},
            {path: 'inventoryAudit', component: InventoryAudit, name: '审核'},
            {path: '/', redirect: 'nowStock'}         //在子路由定向到account
          ]
        },
        {
          path: 'medicine', component: medicine, name: '药房', children: [
            {path: 'medicine_list', component: Medicine_list, name: '抓药列表'},
            {path: 'medicineDetail', component: MedicineDetail, name: '抓药详情'},
            {path: '/', redirect: 'medicine_list'}
          ]
        },
        {
          path: 'patient', component: patient, name: '病人库', children: [
            {path: 'dashboard', component: Dashboard, name: 'Dashboard'},
            {path: 'patientlist', component: Patientlist, name: '病人库'},
            {path: 'addone', component: addone, name: '新增用户'},
            {path: '/', redirect: 'dashboard'}
          ]
        },

        {
          path: 'charge', component: charge, name: '收费', children: [
            {path: 'charge_list', component: Charge_list, name: '收费列表'},
            {path: 'chargeDetail', component: ChargeDetail, name: '收费详情'},
            {path: '/', redirect: 'charge_list'}
          ]
        },
        {
          path: 'subscribeCode', component: subscribeCode, name: '注册码', children: [
            {path: 'subscribeCode_Li', component: subscribeCode_Li, name: '注册码记录'},
            {path: 'createCode', component: createCode, name: '生成注册码'},
            {path: '/', redirect: 'subscribeCode_Li'}
          ]
        },
        {
          path: 'project', component: project, name: '项目',
          children: [
            {path: 'package', component: Package, name: '组方'},
            {path: 'addNew', component: AddNew, name: '添加组方'},
            {path: '/', redirect: 'package'}
          ]
        },
        {
          path: 'reservation', component: Reservation, name: '预约',
          children: [
            {
              path: 'Mrliu', component: Mrliu, children: [
                {path: 'Visdoctor', component: Visdoctor},
                {path: '/', redirect: 'Visdoctor'}
              ]
            }
          ]
        },
        {
          path: 'chapterManagement', component: chapterManagement, name: '用章管理',
          children: [
            {path: 'chapterManagementLi', component: chapterManagementLi, name: '用章管理列表'},
            {path: 'increase', component: increase, name: '新增用章管理'},
            {path: '/', redirect: 'chapterManagementLi'}
          ]
        },
        {
          path: 'performance', component: performance, name: '绩效管理',
          children:[
            {path: 'performanceLi', component: performanceLi, name: '绩效管理列表'},
            {path: 'generate', component: generate, name: '生成绩效管理'},
            {path: '/', redirect: 'performanceLi'}
          ]
        }
      ], redirect: 'home/hello'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js